import axios from 'axios'
import authHeader from './authHeader'
import store from '@/store/index.js'
import url from './url'

const URL = url.currentUrl
const lmsUrl = url.lmsUrl
const aadhaarVerifyUrl = url.aadhaar_verification
const aadhaarOcrUrl = url.aadhaar_ocr

class OnboardingService {
    async signupInit (payload, headers) {
        const response = await axios.post(URL + '/v1/signup', payload, {
            headers
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async signupVerify (payload) {
        const response = await axios.post(URL + '/v1/signup-verify-otp', payload, {
            headers: {
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        })
            .catch(err => {
                if (err.response.status === 401) {
                    store.commit('setSessionOver')
                }
                return err.response
            })
        return response
    }

    async emailVerification (payload) {
        const response = await axios.post(URL + '/v1/verify-email', payload, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async verifyEmailUsingOtp (payload) {
        const response = await axios.post(URL + '/v1/verify-i-email', payload, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async verifyPan (payload) {
        const response = await axios.post(URL + '/v1/pan-authentication?signupType=self', payload, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).catch(err => {
            if (err.response) {
                if (err.response.status === 401) {
                    store.commit('setSessionOver')
                }
                return err.response
            } else if (err.request) {
                return {
                    status: 500
                }
            } else {
                return {
                    status: 500
                }
            }
        })
        return response
    }

    async getAadhaarOtp (payload) {
        const response = await axios.post(URL + '/v3/get-aadhaar-otp', payload, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response) {
                if (err.response.status === 401) {
                    store.commit('setSessionOver')
                }
                return err.response
            } else if (err.request) {
                return {
                    status: 500
                }
            } else {
                return {
                    status: 500
                }
            }
        })
        return response
    }

    async verifyAadhaarOtp (payload) {
        const response = await axios.post(aadhaarVerifyUrl, payload, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response) {
                if (err.response.status === 401) {
                    store.commit('setSessionOver')
                }
                return err.response
            } else if (err.request) {
                return {
                    status: 500
                }
            } else {
                return {
                    status: 500
                }
            }
        })
        return response
    }

    async aadhaarOcr (payload) {
        const response = await axios.post(aadhaarOcrUrl, payload, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response) {
                if (err.response.status === 401) {
                    store.commit('setSessionOver')
                }
                return err.response
            } else if (err.request) {
                return {
                    status: 500
                }
            } else {
                return {
                    status: 500
                }
            }
        })
        return response
    }

    async ocr (payload) {
        const response = await axios.post(URL + '/v1/kyc-ocr?signupType=self', payload, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response) {
                if (err.response.status === 401) {
                    store.commit('setSessionOver')
                }
                return err.response
            } else if (err.request) {
                return {
                    status: 500
                }
            } else {
                return {
                    status: 500
                }
            }
        })
        return response
    }

    async bankVerification (payload) {
        const response = await axios.post(URL + '/v1/bankverify', payload, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response) {
                if (err.response.status === 401) {
                    store.commit('setSessionOver')
                }
                return err.response
            } else if (err.request) {
                return {
                    status: 500
                }
            } else {
                return {
                    status: 500
                }
            }
        })
        return response
    }

    async createVirtualAccount (payload) {
        const response = await axios.post(URL + '/v1/virtual-account', payload, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async checkLiveness (payload) {
        const response = await axios.post('https://testapi.karza.in/v3/liveness-detection', payload, {
            headers: {
                'x-karza-key': '2ftBOkJK8HoveZRw',
                'Content-Type': 'multipart/form-data',
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async sendProfileImage (payload) {
        const response = await axios.post(URL + '/v1/profile-info?signupType=self', payload, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async createPortfolio (payload) {
        const response = await axios.post(lmsUrl + '/v1/investment-portfolio', payload, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async signRequest (payload) {
        const response = await axios.post(URL + '/v1/lender-sign-request?signupType=self', payload, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response) {
                if (err.response.status === 401) {
                    store.commit('setSessionOver')
                }
                return err.response
            } else if (err.request) {
                return {
                    status: 500
                }
            } else {
                return {
                    status: 500
                }
            }
        })
        return response
    }

    async signConfirmationRequest (payload) {
        const response = await axios.post(URL + '/v1/esign-success?signupType=self', payload, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async checkESign () {
        const response = await axios.post(URL + '/v1/esign-check', {}, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async getWidgetToken (payload) {
        const response = await axios.post(URL + '/v1/sign-widget-token?signupType=self', payload, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async getChannelPartner (query) {
        const response = await axios.get(lmsUrl + '/v1/find-channel-partner?' + query, {
            headers: {
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async facebookConversionAPI (payload) {
        const response = await axios.post(lmsUrl + '/v1/facebook/conversion', payload, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async cKycPostData (payload) {
        const response = await axios.post(URL + '/v1/cKyc', payload, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }
}

export default new OnboardingService()
